import { useMemo } from "react";
import { OrderedMap } from "immutable";
import useLayoutVariant from "components/common/PaginatedEntityTable/hooks/useLayoutVariant";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
const nonInfoPriorities = Object.keys(EventDefinitionPriorityEnum.properties).reverse().filter((key) => key !== String(EventDefinitionPriorityEnum.INFO));
const baseDefaultFilters = OrderedMap({
  priority: nonInfoPriorities,
  timestamp: ["relative@2592000"]
});
const useAlertsEntityTableDefaultFilters = (entityTableId) => {
  const { activeLayoutVariant } = useLayoutVariant();
  const {
    data: { defaultFilters }
  } = useUserLayoutPreferences(entityTableId, activeLayoutVariant);
  return useMemo(() => {
    if (defaultFilters) return baseDefaultFilters.merge(defaultFilters);
    return baseDefaultFilters;
  }, [defaultFilters]);
};
export default useAlertsEntityTableDefaultFilters;
